import "../../../../src/styles/main.css";
import HomeResourceCard from "../../../../src/pages/home/home-resource.md";
import HomeMiniCards from "../../../../src/pages/home/home-minicards.md";
import * as React from 'react';
export default {
  HomeResourceCard,
  HomeMiniCards,
  React
};